/**
 * Template gallery
 */

( function( $ ) {
	$('.template-gallery-filters-item').on('click', function() {
		// Remove active from all other filters
		$('.template-gallery-filters-item').each(function() {
			$(this).removeClass('active');
		})

		// Hide the current gallery and show the loader
		$('.template-gallery').addClass('hidden');
		$('.template-gallery-loader').removeClass('hidden');
		$('.template-gallery-loader').addClass('block');


		// Styling change
		$(this).toggleClass('active');

		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: {
				action: 'coefficient_filter_template_gallery',
				category: $(this).data('slug'),
			},
			success: function(res) {
				console.log('Items loaded successfully');
				$('.template-gallery').html(res);
				// Toggle elements
				$('.template-gallery').removeClass('hidden');
				$('.template-gallery-loader').addClass('hidden');
				$('.template-gallery-loader').removeClass('block');
			},
			error: function(xhr, status, error) {
				console.log(error);
				console.log(error.statusText);
				console.log(error.responseText);
				console.log(error.status);
				console.log(xhr.responseText);
				console.log('There was an error loading items. Please contact support if this issue persists');
			}
		});
	});
}( jQuery ) );